module.exports = __webpack_public_path__ + "static/media/icon_driver.b5de5776.svg";